<template>
  <v-btn :tile="tile"
         :disabled="disabled"
         :color="color"
         :text="text"
         :class="btnClass"
         :outlined="outlined"
         :dark="!disabled"
         @click="onClick">
    <slot />
  </v-btn>
</template>

<script>
  export default {
    name: "BaseButton",
    props: {
            disabled: {
        type: Boolean,
        default: false
      },
      color: {
        type: String,
        default: 'bla'
      },
      tile: {
        type: Boolean,
        default: true
      },
     outlined: {
        type: Boolean,
        default: true
      },
      buttonClass: {
        type: String,
        default: ''
      },
      text: {
        type: Boolean,
        default: false
      }

    },
    computed: {
      btnClass () {
         return ['mb-2', 'btnFar', this.buttonClass]
      }
    },
    methods: {
      onClick (event) {
        this.$emit('click', event)
      }
  }}
</script>

<style scoped lang="scss">
  .btnFarDisabled /deep/{
    border: thin solid !important;
    border-color: lightgray !important;


  }
      .btnFarDisabled * /deep/{
      color:lightgray !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/base/BaseButton.vue